import { useEffect } from "react";
import { useRouter } from "next/router";
import { IExtendedSearchProps } from "src/api/server/extended-search";
import { ErrorBoundary } from "src/components/error-handling";
import { Container } from "src/components/layout/container";
import { FilterSortSectionsWrapper } from "src/components/pages/search/filter-sort-sections-wrapper";
import { useFetchResultsOnPageLoad } from "src/components/pages/search/hooks/use-fetch-results-on-page-load";
import { useOnSearchStoreChange } from "src/components/pages/search/hooks/use-on-search-store-change";
import { useSearch } from "src/components/pages/search/hooks/use-search";
import { ResultSection } from "src/components/pages/search/result-section";
import { getGlobals } from "src/consts/globals";

function Page({ data }: IExtendedSearchProps) {
    const wikifolioRanking = {
        id: data.rankingsData.defaultSelectedRanking.id,
        sortDirection: data.rankingsData.defaultSelectedRanking.sortDirection,
    };
    const router = useRouter();
    const { onSearch, onSearchDebounce, resultCount, results, isLoading, isFailed, offset } = useSearch();
    useFetchResultsOnPageLoad({ onSearch, extendedSearchData: data, ranking: wikifolioRanking });
    useOnSearchStoreChange(data);

    useEffect(() => {
        // This page changes URLs dynamically.
        // We want to avoid browser back button to redirect user to previous search query.
        // With router.replace by default the back button redirects the user back to \search, instead of previous (another) page.
        // Therefore on back button click on search, I we need to go back twice, to end up on the proper page.
        router.beforePopState(({ as }) => {
            if (as !== router.asPath) {
                router.back();
            }
            return true;
        });

        return () => {
            router.beforePopState(() => true);
        };
    }, [router]);

    return (
        <>
            <ErrorBoundary>
                <FilterSortSectionsWrapper data={data} resultCount={resultCount} onSearch={onSearchDebounce} isLoading={isLoading} />
            </ErrorBoundary>
            <Container as="section" mb={[5, 10]}>
                <ErrorBoundary>
                    <ResultSection
                        cards={results}
                        resultCount={resultCount}
                        currency={getGlobals()?.currency}
                        onSearch={onSearch}
                        isFailed={isFailed}
                        isLoading={isLoading}
                        hasOffset={Boolean(offset)}
                    />
                </ErrorBoundary>
            </Container>
        </>
    );
}

export default Page;
